import { useMemo } from 'react'
import type { PasswordStrength } from '../../../shared/utils/types'

export function usePasswordStrength(password: string): PasswordStrength {
  return useMemo(() => {
    if (!password) return { score: 0, label: '', color: 'error' }

    let score = 0
    if (password.length >= 8) score++
    if (/[A-Z]/.test(password)) score++
    if (/[0-9]/.test(password)) score++
    if (/[^A-Za-z0-9]/.test(password)) score++

    const levels: PasswordStrength[] = [
      { score: 0, label: '', color: 'error' },
      { score: 1, label: 'weak', color: 'error' },
      { score: 2, label: 'fair', color: 'warning' },
      { score: 3, label: 'good', color: 'info' },
      { score: 4, label: 'excellent', color: 'success' },
    ]

    return levels[score]
  }, [password])
}
